
export default {
  name: "get-title",
  functional: true,
  props: {
    title: {
      type: String,
      requied: true,
      default: "函数式组件的Title"
    },
    titleBackColor: {
      type: String,
      default: "#fff"
    },
    paddingBackTop: {
      type: String,
      default: "72px"
    },
    widthTitle: {
      type: String,
      default: "100%"
    },
    fontSizeTitle: {
      type: String,
      default: "36px"
    },
    textAlignTitle: {
      type: String,
      default: "center"
    },
    fontWeightTitle: {
      type: String,
      default: "400"
    },
    fontFamilyTitle: {
      type: String,
      default: "MicrosoftYaHei, PingFangSC, PingFangSC-Regular"
    },
    colorTitle: {
      type: String,
      default: "#000000"
    }
  },
  render(h, context) {
    return h("h1", {
      style: {
        width: "100%",
        paddingTop: context.props.paddingBackTop,
        backgroundColor: context.props.titleBackColor,
        fontSize: context.props.fontSizeTitle,
        fontFamily: context.props.fontFamilyTitle,
        fontWeight: context.props.fontWeightTitle,
        color: context.props.colorTitle,
        textAlign: context.props.textAlignTitle
      },
      domProps: {
        innerHTML: context.props.title
      }
    })
  }
}


